function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgThunder(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none"
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M18.82 9.18A2 2 0 0017 8h-1.81l1.33-3.26a2 2 0 00-.19-1.84 2.06 2.06 0 00-1.71-.9h-4.34a2 2 0 00-1.91 1.27l-3.23 8a2 2 0 00.2 1.83 2.06 2.06 0 001.71.9h2.76L8 20.74a1 1 0 00.5 1.15A1.12 1.12 0 009 22a1 1 0 00.76-.35l8.8-10.37a2 2 0 00.26-2.1z",
    fill: props.color || 'black'
  }));
}
export default SvgThunder;